module.exports = __webpack_public_path__ + "img/RobecityInternational-hp-top-001.bc32c9b9.jpg";